<template>
    <footer>
        <section class="footer-info d-flex flex-row justify-content-center py-2">
            <p>{{$t('com.file.footer-component.need-help-info-phone')}} <b>61 666 19 77</b> {{$t('com.file.footer-component.need-help-info-or-email')}} <b>pomoc@mwc.pl</b> {{$t('com.file.footer-component.need-help-info-with-id')}} <b>{{this.$store.state.userStore.userData.client_id}}</b> </p>
        </section>
    </footer>
</template>

<script>
    export default {
        name: "FooterComponent",
        components: {

        },
        data() {
            return {
            };
        },
        computed: {

        },
        methods: {
            
        }
    };
</script>

<style lang="scss" scoped>
    .footer-info {
        background: white;
        font-size: 12px;
        text-align: center;
    }
</style>
